import ORDER_API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';
import BASE_API from '@/api/dataBase.js';
import API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';
import { filterEmpty, toLine } from '@/common/js/util';
export default {
  methods: {
    //初始化数据
    getData() {
      // 删除选中的元素
      this.multipleSelection = [];
      this.$refs.siruiTable.clearCheckboxReserve();
      //如果没有查询条件，提示信息
      let count = Object.keys(this.query).length;
      for (var key in this.$refs.siruiSearch.query) {
        if (
          this.$refs.siruiSearch.query[key] == null ||
          this.$refs.siruiSearch.query[key] == undefined ||
          this.$refs.siruiSearch.query[key] == ''
        ) {
          count = count - 1;
        }
      }
      // if (count == 0) {
      //   this.$message({
      //     showClose: true,
      //     message: this.$t("salePurchase.nosearchError"),
      //     type: "error"
      //   });
      //   return;
      // }
      //如果不选制单类型  但是同时输入了意向单和合同号 提示报错
      if (
        this.$refs.siruiSearch.query.intentionNo &&
        this.$refs.siruiSearch.query.contractNo &&
        this.$refs.siruiSearch.query.contractDetailCategory == null
      ) {
        this.$message({
          showClose: true,
          message: this.$t('salePurchase.noTypeSearchError'),
          type: 'error',
        });
        return;
      }
      let params = this.getQueryData();
      //默认 制单日期倒叙
      params.orderByDesc = this.sortParams;
      params.dataGroup = 'wm';
      params.pageSize = this.$refs.siruiTable.page.pageSize;
      params.pageNum = this.$refs.siruiTable.page.pageNum;
      this.load = true;
      this.$axios
        .post(API.GET_LIST_API, {
          ...params,
        })
        .then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            if (this.$refs.siruiTable) {
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
    },
    //处理查询数据
    getQueryData() {
      const query = Object.assign({}, this.$refs.siruiSearch.query);

      query.contractCategory = 'purchase';
      query.groupByContractDetailNoFlag = '1'; //区分当前接口是否为采销合同调用
      //意向单和合同号是同一个字段
      //如果意向单号有值  则将意向单号传给合同号
      if (query.contractDetailCategory == null) {
        query.contractNo = query.intentionNo ? query.intentionNo : query.contractNo;
      } else {
        if (query.contractDetailCategory == 'HT04') {
          query.contractNo = query.intentionNo;
        }
      }
      //客户
      // let item = XEUtils.find(
      //   JSON.parse(this.userInfo.userInfo.companyList),
      //   item => item["personCompanyCode"] === query.customer
      // );

      //仓库
      query.storageNo = this.handleData(query.storage, 'storageCode');
      //商品描述
      // query.productNo = this.handleData(query.product, 'productDetailCode');
      //业务员ContractSalesmanNo
      query.contractSalesmanNo = this.handleData(query.contractSalesman, 'id');
      //操作人
      query.contractOperaterNo = this.handleData(query.contractOperaterNo, 'id');
      //业务公司赋初值
      // query.contractBusinessCompanyNo = this.userInfo.userInfo.companyCode;
      // query.contractBusinessCompanyName = this.userInfo.userInfo.companyName;
      //供应链主体
      query.supplychainNo = this.handleData(query.supplychain, 'supplierCode');
      //供应商
      query.supplierNo = this.handleData(query.supplier, 'partnerCode');
      //业务订单
      query.businessOrder = query.businessOrder ? query.businessOrder[0].orderNo : null;
      delete query.contractSalesman;
      return filterEmpty({ ...query });
    },
    //处理数据
    handleData(multipleSelection, key) {
      let selectList = multipleSelection ? multipleSelection : [];
      let list = [];
      selectList.forEach((item) => {
        if (key == 'partnerCode') {
          //合并的数据
          if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
            list.push(item.allPartnerCode);
          } else {
            list.push(item[key]);
          }
        } else if (key == 'supplierCode') {
          //合并的数据
          if (item.allSupplierCode && item['allSupplierCode'] != undefined) {
            list.push(item.allSupplierCode);
          } else {
            list.push(item[key]);
          }
        } else if (key == 'productDetailCode') {
          //合并的数据
          if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
            list.push(item.allProductDetailCode);
          } else {
            list.push(item[key]);
          }
        } else {
          if (item[key] && item[key] != undefined) {
            list.push(item[key]);
          }
        }
      });
      return list.length != 0 ? list.join(',') : null;
    },
    //搜索区域控制切换事件
    changeMethod(obj) {
      console.log(obj, '???');
      if (obj.prop == 'projectInitiationNo') {
        const rowData = (obj.val && obj.val[0]) || {};
        this.query.projectInitiationNo = rowData.projectInitiationNo;
      }
      if (obj.prop == 'product') {
        this.query.productNo = obj.val[0].parentProductNo;
      }
      let arr = ['HT01', 'HT02', 'HT03'];
      //如果是意向单,则意向单号可填，合同号禁用
      if (obj.val == 'HT04') {
        this.contDisabled = true;
        this.intDisabled = false;
        this.query.contractNo = null;
      } else if (arr.includes(obj.val)) {
        //如果是合同或协议,则合同号可填，意向单号禁用
        this.intDisabled = true;
        this.contDisabled = false;
        this.query.intentionNo = null;
      } else {
        this.intDisabled = false;
        this.contDisabled = false;
        this.query.intentionNo = null;
        // this.query.contractNo = null;
      }
    },
    //排序
    sortChangeEvent({ property, order }) {
      // this.sortParams = "tos.contract_create_date desc";
      if (order) {
        if (['contractTotalAmount', 'contractCreateDate'].indexOf(property) > -1) {
          this.sortParams = `tos.${toLine(property)} ${order}`;
        } else {
          this.sortParams = `tosd.${toLine(property)} ${order}`;
        }
      } else {
        this.sortParams = '';
      }
      this.getData();
    },
    //获取部门
    async getDepartment() {
      const params = {
        id: this.userInfo.userInfo.userCode,
        userCode: this.userInfo.userInfo.userCode,
        personName: this.userInfo.userInfo.userName,
        personCompanyCode: this.userInfo.userInfo.companyCode,
      };
      const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
      this.departmentList = selectStatus.data.data.personDepartmentInfo;
      this.departmentList.forEach((item) => {
        item.value = item.personDepartmentCode;
        item.label = item.personDepartmentName;
      });
    },
    resetBtnClick() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.$refs.siruiTable.clearCheckboxReserve();
      this.$refs.siruiSearch.$refs.productRef &&
        this.$refs.siruiSearch.$refs.productRef[0] &&
        this.$refs.siruiSearch.$refs.productRef[0]?.resetClick();
      this.query.productNo = '';
      this.query.companyName = '';
      // this.query.customer = this.userInfo.userInfo.companyCode;
      this.getData();
    },
    dblclickEvent(value) {
      console.log(value, '双击行');

      //已生效的 只能修改关联明细和点价已经结算批次
      const contractDetailCategory = value.row.contractDetailCategory;
      const contractNo = value.row.contractNo;
      console.log(contractDetailCategory, '==当前类型=??');
      // const contractStatus = value.row.contractStatus;
      const id = value.row.id;
      let path = {};
      //采购协议
      if (contractDetailCategory == 'CG02') {
        path = {
          path: '/salePurchase/wumaoAgreementEdit',
          name: 'wumaoAgreementEdit',
          meta: {
            keepAlive: true,
            title: '采购协议编辑',
          },
          query: {
            id: id,
            type: contractDetailCategory,
            contractNo: contractNo,
            isEdit: true,
            copy: '0',
            contractCategory: 'purchase',
          },
        };
      }
      // 采购合同
      if (contractDetailCategory == 'CG01') {
        path = {
          path: '/salePurchase/wumaoContractEdit',
          name: 'wumaoContractEdit',
          meta: {
            keepAlive: true,
            title: '采购合同编辑',
          },
          query: {
            id: id,
            type: contractDetailCategory,
            contractNo: contractNo,
            isEdit: true,
            contractCategory: 'purchase',
          },
        };
      }
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    chooseClick(type) {
      console.log(type);
      this[type]();
    },
    // 复制合同
    copy() {
      console.log(this.multipleSelection, '行');
      if (this.multipleSelection.length != 1) {
        this.$message.warning('只能选择一行操作');
        return;
      }
      //已驳回状态不可复制
      // if (this.multipleSelection[0].contractStatus != 'ZT03') {
      //   // let type = this.query.contractDetailCategory;
      //   // let tips =
      //   //   type === 'HT03'
      //   //     ? 'noCopyContractTips'
      //   //     : type === 'HT04'
      //   //     ? 'noCopyIntentionTips'
      //   //     : 'noCopyAgreementTips';
      //   this.$message({
      //     showClose: true,
      //     message: '只能复制已生效的协议/合同',
      //     type: 'error',
      //   });
      //   return;
      // }
      //跳转到复制即新增页面
      // this.handleCopyPath(
      //   this.multipleSelection[0].contractDetailCategory,
      //   this.multipleSelection[0].contractNo
      // );
      let path = {};
      const rowData = this.multipleSelection[0];
      const contractDetailCategory = rowData.contractDetailCategory;
      const contractNo = rowData.contractNo;
      const id = rowData.id;
      // 采购合同
      if (contractDetailCategory == 'CG01') {
        path = {
          path: '/salePurchase/wumaoContractCreate',
          name: 'wumaoContractCreate',
          meta: {
            keepAlive: true,
            title: '复制采购合同',
          },
          query: {
            type: contractDetailCategory,
            contractNo: contractNo,
            contractCategory: 'purchase',
            isCopy: 'true',
            isEdit: 'false',
            id,
          },
        };
      }
      // 采购协议
      if (contractDetailCategory == 'CG02') {
        path = {
          path: '/salePurchase/wumaoAgreementCreate',
          name: 'wumaoAgreementCreate',
          meta: {
            keepAlive: true,
            title: '拷贝采购协议',
          },
          query: {
            type: contractDetailCategory,
            contractNo: contractNo,
            contractCategory: 'purchase',
            isCopy: 'true',
            isEdit: 'false',
            id,
          },
        };
      }
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },

    // 关闭合同
    closeContract() {
      this.updateStatusHandler(0);
    },
    // 创建新单
    addOrder() {
      // 弹框显示是合同还是协议
      this.$refs.choiceTypeRef.openDialog(true, 'purchase_contract_detail_category');
    },
    // 删除
    delete() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          showClose: true,
          message: this.$t('contractAgency.errorTips.deleteEmptyTip'),
          type: 'error',
        });
        return;
      }
      //可删除条件
      let isDelete = true;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (
          this.multipleSelection[i].contractStatus != 'ZT06' &&
          this.multipleSelection[i].contractStatus != 'ZT05'
        ) {
          isDelete = false;
          break;
        }
      }
      if (!isDelete) {
        let type = this.query.contractDetailCategory;
        let tips =
          type === 'HT03'
            ? 'noDeleteContractTips'
            : type === 'HT04'
            ? 'noDeleteIntentionTips'
            : 'noDeleteAgreementTips';
        this.$message({
          showClose: true,
          message: this.$t(`salePurchase.${tips}`),
          type: 'error',
        });
        return;
      }
      this.$confirmAction()
        .then(() => {
          let ids = [];
          let contractNos = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
            contractNos.push(item.contractNo);
          });
          this.loading.startLoading();
          this.$axios
            .post(API.DELETE_ORDER_API, {
              ids: ids,
              contractNos: contractNos,
              oaId: this.userInfo.userInfo.oaId,
            })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                this.$alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('confirm.deleteCancelled'),
          });
        });
    },
    // 提交审批
    submit() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          showClose: true,
          message: '请选择已保存采购合同/协议进行提交',
          type: 'error',
        });
        return;
      }
      const isGenerateSales = this.multipleSelection.some((item) => item.isGenerateSales);
      if (isGenerateSales) {
        this.$message.warning('该合同已有关联销售合同，请到详情页提交审批');
        return;
      }
      //只有已保存和已驳回的才可以提交
      let isSubmit = true;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if (
          this.multipleSelection[i].contractStatus != 'ZT06' &&
          this.multipleSelection[i].contractStatus != 'ZT05' &&
          this.multipleSelection[i].contractStatus != 'ZT061' &&
          this.multipleSelection[i].contractStatus != 'ZT051'
        ) {
          isSubmit = false;
          break;
        }
      }
      if (!isSubmit) {
        let type = this.query.contractDetailCategory;
        let tips =
          type === 'HT03'
            ? 'noSubmitContractTips'
            : type === 'HT04'
            ? 'noSubmitIntentionTips'
            : 'noSubmitAgreementTips';
        this.$message({
          showClose: true,
          message: this.$t(`salePurchase.${tips}`),
          type: 'error',
        });
        return;
      }
      // for (let i = 0; i < this.multipleSelection.length; i++) {
      //   if (
      //     this.multipleSelection[i].contractTotalAmount == 0 ||
      //     !this.multipleSelection[i].contractTotalAmount
      //   ) {
      //     this.$message({
      //       showClose: true,
      //       message: this.multipleSelection[i].contractNo + '合同总金额为0,无法提交',
      //       type: 'error',
      //     });
      //     return;
      //   }
      // }
      let contractNos = [];
      let requestIds = [];
      this.multipleSelection.forEach((item) => {
        contractNos.push(item.contractNo);
        if (item.requestId) {
          requestIds.push(item.requestId);
        }
      });
      // this.loading.startLoading();
      this.$confirmAction(this.$t('confirm.submit'), this.$t('confirm.removeSubmit'))
        .then(() => {
          this.batchSubmit({
            contractNos: contractNos,
            oaId: this.userInfo.userInfo.oaId,
            requestIds: requestIds,
            contractCategory: 'purchase',
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: this.$t('salePurchase.message.gitUpSubmit'),
          });
          this.loading.endLoading();
        });
    },
    batchSubmit(value) {
      this.loading.startLoading();
      this.$axios.post(API.SUBMIT_ORDER_API, value).then((res) => {
        this.loading.endLoading();
        if (0 == res.data.code) {
          this.$message({
            type: 'success',
            message: this.$t('message.success'),
          });
          this.searchBtnClick();
        } else {
          this.$reportErrors({
            msg: res.data.msg,
            code: res.data.code,
            callback: () => {
              value.cancelValidate = true;
              this.batchSubmit(value);
              this.searchBtnClick();
            },
            callback2: () => {
              this.searchBtnClick();
            },
          });
        }
      });
    },
    // 创建供货商发货指令
    addSupplierDelivery() {
      // 需选择一条已生效的且为采购合同或意向单的数据进行供应商发货
      let addSupplierDelivery = true;
      if (
        this.multipleSelection.length != 1 ||
        this.multipleSelection[0].contractStatus != 'ZT03'
      ) {
        addSupplierDelivery = false;
      } else {
        if (
          this.multipleSelection[0].contractDetailCategory == 'HT01' ||
          this.multipleSelection[0].contractDetailCategory == 'HT02' ||
          this.multipleSelection[0].contractDetailCategory == 'CG02'
        ) {
          addSupplierDelivery = false;
        }
      }
      if (!addSupplierDelivery) {
        this.$message({
          showClose: true,
          message: '请勾选一条已生效合同',
          type: 'error',
        });
        return;
      } else {
        let path = {
          path: '/wareHouse/addMateriaSupplierDeliveryOrder',
          name: 'addMateriaSupplierDeliveryOrder',
          meta: {
            keepAlive: true,
            title: '创建供应商发货指令',
          },
          query: {
            contractNo: this.multipleSelection[0].contractNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      }
    },
    // 导出
    export() {
      const tableColumn = this.$refs.siruiTable.getTableColumn();
      const showColumns = [];
      tableColumn.visibleColumn.forEach((item) => {
        if (item.property) {
          showColumns.push({ prop: item.property, label: item.title });
        }
      });
      showColumns.unshift({ prop: 'rowNo', label: '序号' });
      const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
      //如果当前页和历史页没有记录 ，则看搜索区域
      if (this.multipleSelection.length == 0 && selectedList.length == 0) {
        this.$message({
          showClose: true,
          message: '请至少选择一条数据进行导出',
          type: 'error',
        });
        return;
      }
      const query = this.getQueryData();
      const params = filterEmpty(query);
      params.dataGroup = 'wm';
      params.idsExport = [];
      if (selectedList.length > 0) {
        selectedList.map((item) => {
          params.idsExport.push(item.id);
        });
      }
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.map((item) => {
          params.idsExport.push(item.id);
        });
      }
      // 导出字段
      params.columns = JSON.stringify(showColumns);
      //默认 制单日期倒叙
      params.orderByDesc = this.sortParams;

      this.loading.startLoading();
      // 获取数据
      this.$axios.post(API.EXPORT_ORDER_API, params).then((res) => {
        this.loading.endLoading();
        if (res.data.code === 0) {
          window.location.href = res.data.data;
        } else {
          this.$alert(res.data.msg);
        }
      });
    },
    // 导入
    import() {
      this.$refs.siruiUpload.openDialog(true, '02');
    },
    // 正本收集
    originalsReceivedBusiness() {
      this.originalsReceived('originalsReceivedBusiness');
    },
    // 正本归档
    originalsReceivedRm() {
      //正本归档
      this.originalsReceived('originalsReceivedRm');
    },
    // 删除申请
    deleteApply() {
      if (this.multipleSelection?.length == 0) {
        this.$message({
          showClose: true,
          message: '请至少选择一条数据进行操作',
          type: 'error',
        });
        return;
      }
      if (this.multipleSelection?.length > 1) {
        this.$message({
          showClose: true,
          message: '只能删除一条已生效且未创建供应商发货指令的合同，或已生效的协议',
          type: 'error',
        });
        return;
      }
      this.$confirmAction('提交删除申请', '是否确认提交删除申请？')
        .then(() => {
          // let ids = [];
          let contractNos = [];
          this.multipleSelection.forEach((item) => {
            contractNos.push(item.contractNo);
          });
          contractNos = this.unique(contractNos);
          this.loading.startLoading();
          this.$axios
            .post(API.DELETE_CONTRACT_COMMIT, {
              contractNos: contractNos,
              oaId: this.userInfo.userInfo.oaId,
            })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                this.$alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('confirm.deleteCancelled'),
          });
        });
    },
    // 关闭、激活、撤销
    updateStatusHandler(type) {
      const selectedList = this.$refs.siruiTable
        .getCheckboxRecords()
        .concat(this.$refs.siruiTable.getCheckboxReserveRecords()); // 当前页选中
      if (selectedList.length != 1) {
        this.$message({
          showClose: true,
          message: '只能选择一行操作',
          type: 'error',
        });
        return;
      }
      const rowData = selectedList[0];
      console.log(rowData.contractStatus, '====', rowData.id);
      if (rowData.contractStatus !== 'ZT03') {
        this.$message({
          showClose: true,
          message: '只能选择已生效合同/协议才能操作！',
          type: 'error',
        });
        return;
      }

      this.$confirm('确定要更改合同状态', '确认更改状态', {})
        .then(async () => {
          this.loading.startLoading();
          //0-关闭 1-激活 2-撤销
          let postData = {
            id: rowData.id,
            operateFlag: type,
            oaId: this.userInfo.userInfo.oaId,
          };
          const res = await this.$axios.post(ORDER_API.UPDATE_OTDER_STATUS, postData);
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    //正本操作
    originalsReceived(type) {
      const selectedList = this.$refs.siruiTable
        .getCheckboxRecords()
        .concat(this.$refs.siruiTable.getCheckboxReserveRecords()); // 当前页选中
      if (selectedList.length === 0) {
        this.$message({
          showClose: true,
          message: this.$t('xTable.noSelectData'),
          type: 'error',
        });
        return;
      }
      if (selectedList.find((item) => item.contractStatus !== 'ZT03')) {
        this.$message({
          showClose: true,
          message: '只有已生效合同才能操作！',
          type: 'error',
        });
        return;
      }
      this.$refs.OriginalsReceivedDialog.openDialog(true, type, {
        contractNo: selectedList.map((item) => item.contractNo),
      });
    },
    // 撤回审批
    withdrawApprovalHandler() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择行');
        return;
      }
      // 判断只有审批中的才可以
      if (this.multipleSelection.some((item) => item.contractStatus != 'ZT02')) {
        this.$message.error('只有审批中才可以撤回审批');
        return false;
      }
      let contractNos = [];
      let requestIds = [];
      this.multipleSelection.forEach((item) => {
        contractNos.push(item.contractNo);
        if (item.requestId) {
          requestIds.push(item.requestId);
        }
      });
      this.loading.startLoading();
      this.$axios
        .post('/sales/order/batchAuditWithdrawOA', {
          contractNos: contractNos,
          requestIds: requestIds,
          contractCategory: 'purchase',
          oaId: this.userInfo.oaId,
        })
        .then((res) => {
          const { code, msg } = res.data;
          this.loading.endLoading();
          if (code == 0) {
            this.resetBtnClick();
            this.$message.success('撤回成功');
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
        });
    },
    unique(array) {
      let temp = [];
      let index = [];
      let l = array.length;
      for (let i = 0; i < l; i++) {
        for (let j = i + 1; j < l; j++) {
          if (array[i] === array[j]) {
            i++;
            j = i;
          }
        }
        temp.push(array[i]);
        index.push(i);
      }
      return temp;
    },
    // 后台审批
    backendApproval() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择行');
        return;
      }

      const idList = this.multipleSelection.map((item) => item.id);
      this.loading.startLoading();
      this.$axios
        .post('/sales/order-service-remote/backendApproval', idList)
        .then((res) => {
          const { code, msg } = res.data;
          this.loading.endLoading();
          if (code == 0) {
            this.resetBtnClick();
            this.$message.success('后台审批成功');
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
        });
    },
  },
};
